import { Schema } from '.';

const bepSchema: Schema = [
  {
    name: 'USER_ID',
    type: 'STRING',
    mode: 'NULLABLE',
    nomap: true,
  },
  {
    name: 'INGEST_ID',
    type: 'STRING',
    mode: 'NULLABLE',
    nomap: true,
  },
  {
    name: 'DELETED',
    type: 'TIMESTAMP',
    mode: 'NULLABLE',
    nomap: true,
  },
  {
    name: 'TRADE_ID',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TRADE_DATETIME',
    type: 'TIMESTAMP',
    mode: 'REQUIRED',
  },
  {
    name: 'IDENTIFIER_TYPE',
    type: 'STRING',
    mode: 'REQUIRED',
  },
  {
    name: 'IDENTIFIER',
    type: 'STRING',
    mode: 'REQUIRED',
  },
  {
    name: 'DESCRIPTION',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'SIDE',
    type: 'STRING',
    mode: 'REQUIRED',
  },
  {
    name: 'NOTIONAL_TRADED',
    type: 'FLOAT',
    mode: 'REQUIRED',
  },
  {
    name: 'NOTIONAL_ORDERED',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'TRADE_PRICE',
    type: 'NUMERIC',
    mode: 'REQUIRED',
  },
  {
    name: 'CURRENCY',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'DEAL_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'STATUS',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TRADE_DESK',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TRADER',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'VENUE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'PM',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'ACCOUNT',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'EVENT_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'BENCHMARK',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'EXPLICIT_COST',
    type: 'NUMERIC',
    mode: 'NULLABLE',
  },
  {
    name: 'ORDER_ID',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'ORDER_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'SECURITY_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'SECURITY_SUB_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'INSTRUMENT_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TRADE_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'DESK_LOCATION',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'COVER_PRICE',
    type: 'NUMERIC',
    mode: 'NULLABLE',
  },
  {
    name: 'LIMIT_PRICE',
    type: 'NUMERIC',
    mode: 'NULLABLE',
  },
  {
    name: 'INSTRUCTIONS',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'FUND',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'STRATEGY',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'BROKER',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'DEALER',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'OTHER_1',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'CUSTOM_BENCHMARK_1',
    type: 'NUMERIC',
    mode: 'NULLABLE',
  },
  {
    name: 'CUSTOM_BENCHMARK_2',
    type: 'NUMERIC',
    mode: 'NULLABLE',
  },
  {
    name: 'CUSTOM_BENCHMARK_3',
    type: 'NUMERIC',
    mode: 'NULLABLE',
  },
  {
    name: 'CUSTOM_BENCHMARK_4',
    type: 'NUMERIC',
    mode: 'NULLABLE',
  },
  {
    name: 'GROUP_ID',
    type: 'STRING',
    mode: 'REQUIRED',
  },
  {
    name: 'LEGAL_ENTITY',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'ORDER_DATETIME',
    type: 'TIMESTAMP',
    mode: 'NULLABLE',
  },
  {
    name: 'PLATFORM',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'PORTFOLIO_ID',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TRADE_CAPACITY',
    type: 'NUMERIC',
    mode: 'NULLABLE',
  },
  {
    name: 'CUSTOM_1',
    type: 'DATE',
    mode: 'NULLABLE',
  },
  {
    name: 'CUSTOM_2',
    type: 'TIMESTAMP',
    mode: 'NULLABLE',
  },
  {
    name: 'CUSTOM_3',
    type: 'STRING',
    mode: 'NULLABLE',
  },
].sort((a, b) => {
  if (a.name < b.name) return -1;
  if (a.name > b.name) return 1;
  return 0;
});

export default bepSchema;
